export default __webpack_public_path__ + "static/media/aboutus1.b8381312.png";